<div class="search-header">
  <mat-form-field appearance="fill" class="size-s w-full">
    <dojo-icon icon="search" matPrefix class="mr-0.5" [iconClass]="'text-neutral-500'" />
    <input matInput [formControl]="searchControl" [placeholder]="searchPlaceholder()" />
  </mat-form-field>
</div>

<div class="tags-list">
  @for (tag of filteredTags(); track tag.id) {
    <div class="tag-item" (click)="toggleTag(tag.id)">
      <mat-checkbox
        color="primary"
        [checked]="isSelected(tag.id)"
        [disableRipple]="true"
        (click)="$event.stopPropagation()"
        (change)="toggleTag(tag.id)"
      />
      <dojo-tag-badge [name]="tag.name" [color]="tag.color" [emoji]="tag.emoji" />
    </div>
  } @empty {
    <div class="empty-text">{{ 'examdojo.tags.no_tags_found' | transloco }}</div>
  }
</div>
